// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileEmptyState-cls1_gJ8","cls2":"ProfileEmptyState-cls2_FiH ProfileEmptyState-cls1_gJ8"};